// extracted by mini-css-extract-plugin
export default {"AurBasicChipsContainer":"styles_AurBasicChipsContainer__luMp4","aurDeleteButtonIcon":"styles_aurDeleteButtonIcon__gDXKm","AurBasicChip":"styles_AurBasicChip__E4++m"};